<template>
  <div class="basket-menu">
    <router-link to="/basket">
      <img
        :src="header ? headerIcon : defaultIcon"
        alt="Корзина"
      >
    </router-link>
    <span class="quantity" v-if="getAmountOfProducts">{{ getAmountOfProducts }}</span>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  export default {
    props: {
      header: {
        type: Boolean,
        default: false,
      },
    },

    data() {
      return {
        defaultIcon: require('../assets/images/icons/icon-basket.svg'),
        headerIcon: require('../assets/images/icons/icon-basket-header.svg'),
      }
    },

    computed: {
      ...mapGetters(['getAmountOfProducts']),
    },

    created() {
      this.$store.dispatch('fetchBasket')
    }
  }
</script>

<style lang="scss" scoped>
  .basket-menu {
    width: 20px;
    position: relative;

    img {
      display: block;
      width: 20px;
      height: 20px;
    }
  }

  .quantity {
    display: block;
    font: 400 12px $roboto;
    color: #F9F9F9;
    position: absolute;
    right: -6px;
    top: -8px;
  }
</style>
